
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDelta as ObiDeltaElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-delta.js';
 
 
 

 
 export const ObiDelta = createComponent({
   react: React,
   tagName: 'obi-delta',
   elementClass: ObiDeltaElement,
   events: {
     
   }
  });
 
 